import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tableChangesAnnouncement: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.table-changes-announcement',
		defaultMessage: '{users} changed {changes}',
		description:
			'This is the text to indicate who are the authors who made the changes in the changes table, for visually hidden announcement after table content updated with lastmodified filter. {users} is the string of users who made the changes and {changes} is the user contributed changes in jira',
	},
	changedCategoryCount: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.changed-category-count',
		defaultMessage: '{categoryCount, plural, one {# {changeCategory}} other {# {changeCategory}s}}',
		description:
			'This is the text to indicate what and how many changes are made based on category, for visually hidden announcement after table content updated with lastmodified filter. where {categoryCount} number of changes in a particular category, {changeCategory} is the category which was changed',
	},
	allUsers: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.all-users',
		defaultMessage: 'All users',
		description:
			'Text for visually hidden announcement when all users filter is selected in last modified',
	},
	stringConnecter: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.update-jira.changes-table.visually-hidden-announcement.string-connecter',
		defaultMessage: '{items} and {lastItem}',
		description:
			'This is the string formed after joining the array of strings for lastmodified authors and changed category count',
	},
});
